import { render, staticRenderFns } from "./login-phone.vue?vue&type=template&id=6ec6663c&lang=pug&"
import script from "./login-phone.vue?vue&type=script&lang=js&"
export * from "./login-phone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports